import { render, staticRenderFns } from "./ChannelTypeDayClear.vue?vue&type=template&id=0175e40d&"
import script from "./ChannelTypeDayClear.vue?vue&type=script&lang=ts&"
export * from "./ChannelTypeDayClear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelTypeDayClear.vue"
export default component.exports